export default __webpack_public_path__ + "static/media/330_private03-en-mobile.b0059599.png";